import React from 'react';
import { ReactComponent as Code } from '../../assets/Icons/lucideIcons/code.svg';
import { ReactComponent as FormatListBulleted } from '../../assets/Icons/lucideIcons/list.svg';
import { ReactComponent as FormatListNumbered } from '../../assets/Icons/lucideIcons/list-ordered.svg';
import { ReactComponent as FormatQuote } from '../../assets/Icons/lucideIcons/quote.svg';
import { ReactComponent as FormatUnderlined } from '../../assets/Icons/lucideIcons/underline.svg';
import { ReactComponent as Highlight } from '../../assets/Icons/lucideIcons/flashlight.svg';
import { ReactComponent as StrikethroughS } from '../../assets/Icons/lucideIcons/strikethrough.svg';
import { ReactComponent as Terminal } from '../../assets/Icons/lucideIcons/square-terminal.svg';
import { Typography } from '@mui/material';

/**
 * @typedef SolyticsEditorToolbarItem
 * @property {'toggle' | 'divider' | 'heading'} type
 */

const toolbarItems = [
  {
    type: 'undo',
    title: 'Undo',
  },
  {
    type: 'redo',
    title: 'Redo',
  },
  {
    type: 'divider',
  },
  {
    type: 'heading',
    title: 'Change Heading',
  },
  {
    type: 'fontSize',
    title: 'Change Font Size',
  },
  {
    action: 'bold',
    buttonContent: <Typography>B</Typography>,
    type: 'toggle',
    title: 'Toggle Bold',
  },
  {
    action: 'italic',
    buttonContent: (
      <Typography>
        <em>I</em>
      </Typography>
    ),
    type: 'toggle',
    title: 'Toggle Italic',
  },
  {
    type: 'toggle',
    buttonContent: <FormatUnderlined width={18} height={18} />,
    action: 'underline',
    title: 'Toggle Underline',
  },
  {
    type: 'toggle',
    action: 'strike',
    buttonContent: <StrikethroughS width={18} height={18} />,
    title: 'Toggle Strike',
  },
  {
    type: 'toggle',
    action: 'highlight',
    buttonContent: <Highlight width={18} height={18} />,
    title: 'Toggle Highlight',
  },
  {
    type: 'divider',
  },
  {
    type: 'textAlign',
    title: {
      left: 'Align Left',
      right: 'Align Right',
      justify: 'Justify',
      center: 'Align Center',
    },
  },
  {
    type: 'divider',
  },
  {
    type: 'toggle',
    action: 'bulletList',
    buttonContent: <FormatListBulleted width={18} height={18} />,
    title: 'Toggle BulletList',
  },
  {
    type: 'toggle',
    action: 'orderedList',
    buttonContent: <FormatListNumbered width={18} height={18} />,
    title: 'Toggle OrderedList',
  },
  {
    type: 'divider',
  },
  {
    type: 'toggle',
    action: 'code',
    buttonContent: <Code width={18} height={18} />,
    title: 'Toggle Code',
  },
  {
    type: 'toggle',
    action: 'codeBlock',
    buttonContent: <Terminal width={18} height={18} />,
    title: 'Toggle CodeBlock',
  },

  {
    type: 'toggle',
    action: 'blockquote',
    buttonContent: <FormatQuote width={18} height={18} />,
    title: 'Toggle BlockQuote',
  },
  {
    type: 'divider',
  },
  {
    type: 'link',
    title: 'Link',
  },
  {
    type: 'image',
    title: 'Image',
  },
  {
    type: 'table',
    title: 'Table',
  },
  {
    type: 'youtube',
    title: 'YouTube',
  },
  {
    type: 'iframe',
    title: 'Iframe',
  },
  {
    type: 'AdvanceTableWithFields',
    title: 'Advanced table with fields',
  },
  {
    type: 'addChart',
    title: 'Add chart',
  },
];

export default toolbarItems;
